import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  VEHICLE_VALUATION_COST_ADDITION_API_PATH,
  VEHICLE_VALUATION_COST_ADDITION_RESOURCE,
  type VehicleValuationCostAdditionPutBody,
  type VehicleValuationCostAdditionPutResponse,
} from "./vehicle-valuation-cost-addition.types";

export function useVehicleValuationCostAdditionPutMutation() {
  const queryClient = useQueryClient();

  return useMutation<VehicleValuationCostAdditionPutResponse, Error, VehicleValuationCostAdditionPutBody>({
    mutationFn: async (body) => {
      const response = await alphartisApiAxios.put<VehicleValuationCostAdditionPutResponse>(
        VEHICLE_VALUATION_COST_ADDITION_API_PATH,
        body,
      );

      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [VEHICLE_VALUATION_COST_ADDITION_RESOURCE],
      });
    },
  });
}
